import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Video14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6 9C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 2.25C0.809644 2.25 0.25 2.80964 0.25 3.5V10.5C0.25 11.1904 0.809644 11.75 1.5 11.75H8.5C9.19036 11.75 9.75 11.1904 9.75 10.5V9.96061L12.1967 10.5723C12.9857 10.7695 13.7499 10.1728 13.7499 9.35961V4.64039C13.7499 3.82717 12.9857 3.23047 12.1967 3.42771L9.75 4.03939V3.5C9.75 2.80964 9.19036 2.25 8.5 2.25H1.5ZM9.75 5.58555V8.41444L12.2499 9.03942V4.96058L9.75 5.58555ZM1.75 10.25V3.75H8.25V10.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Video14.displayName = 'Video14';
export default Video14;
